__turbopack_context__.v({
  "donate_search_row": "_5egDqG_donate_search_row",
  "donate_search_row__button": "_5egDqG_donate_search_row__button",
  "donate_search_row__content": "_5egDqG_donate_search_row__content",
  "donate_search_row__description": "_5egDqG_donate_search_row__description",
  "donate_search_row__image": "_5egDqG_donate_search_row__image",
  "donate_search_row__logo": "_5egDqG_donate_search_row__logo",
});
